import { EmailThread } from "../../../Components/MailApp/MailAppInterfaces";

export const Area51Mail: EmailThread[] = [
  {
    Emails: [
      {
        Date: "15 Sep 2024",
        Time: "10:37am",
        Author: "jonmcfadden@thetimes.co.uk",
        Receiver: "noemie.boljvic@mail.co.uk",
        Subject: "Publishing U.S. Military Secrets",
        Text: "Noémie, where are you?\nI'm here in the lobby.\n\nJon",
      },
      {
        Date: "2 Sep 2024",
        Time: "4:39pm",
        Author: "noemie.boljvic@mail.co.uk",
        Receiver: "jonmcfadden@thetimes.co.uk",
        Subject: "Publishing U.S. Military Secrets",
        Text: "Hi Jon,\n\nFantastic. I’ve booked mine too. See you there!\nPs. as always, Natalia is the only other person who knows about this.\n\nBests,\nNoémie",
      },
      {
        Date: "2 Sep 2024",
        Time: "10:19am",
        Author: "jonmcfadden@thetimes.co.uk",
        Receiver: "noemie.boljvic@mail.co.uk",
        Subject: "Publishing U.S. Military Secrets",
        Text: "Hi Noémie,\n\nI'll keep this one short. I've booked my flight to Panama City on the 14th. I'll be staying at the Maristone hotel which is right in the center of town. We'll meet in the lobby at 9pm, local time.\n\nJon",
      },
    ],
  },
  {
    Emails: [
      {
        Date: "11 Sep 2024",
        Time: "10:41am",
        Author: "noemie.boljvic@mail.co.uk",
        Receiver: "generalhljohnson@area51.co.uk",
        Subject: "Meeting",
        Text: "Noted. See you then.\n\nNoémie",
      },
      {
        Date: "11 Sep 2024",
        Time: "10:37am",
        Author: "generalhljohnson@area51.co.uk",
        Receiver: "noemie.boljvic@mail.co.uk",
        Subject: "Meeting",
        Text: "Noémie,\n\nPlease come to my office at 12:00pm midday today for a meeting.\n\nHLJ",
      },
    ],
  },
];
